import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { SignatureAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/signature-answer-config.model';
import { PaetepCfSignatureModel } from 'src/app/components/custom-form-enhancements/edl-cf-extensions/item-models/paetep-cf-signature.model';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { EdlCfGenericModel, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { CustomFormSignatureType } from 'src/app/model/enum/observations/custom-forms/custom-form-signature-type.enum';
import { PaetepCfAnswerSignatureModel } from 'src/app/components/custom-form-enhancements/edl-cf-extensions/answer-models/paetep-cf-answer-signature.model';
import { EdlCfSignatureAnswer } from 'src/app/model/observation/custom-forms/answers/paetep-cf-signature-answer.model';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfSignatureMapperService implements IPaetepCfGenericMapperService<SignatureAnswerConfig, PaetepCfSignatureModel, EdlCfSignatureAnswer, PaetepCfAnswerSignatureModel> {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<SignatureAnswerConfig>): PaetepCfSignatureModel=> {
        return {
            title: child.label,
            option: child.answerConfig?.option
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<PaetepCfSignatureModel>
    }): CustomFormQuestionDisplayDTO<SignatureAnswerConfig> =>  {
        return this.customFormsHelpersService.createCustomFormQuestion<SignatureAnswerConfig>({
            $type: CustomFormQuestionType.SIGNATURE,
            typeID: CustomFormQuestionType.SIGNATURE,
            formID,
            sectionID,
            questionID: question.id,
            readOnly: false,
            required: false,
            displayOrder,
            groupOrder,
            label: (question.config.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                option: question.config.option ?? CustomFormSignatureType.SUPERVISOR
            }
        });
    }

    public toEdlAnswer = (answer: EdlCfSignatureAnswer, question: CustomFormQuestionDisplayDTO<SignatureAnswerConfig>) => answer;
}
